import { Component, inject, OnInit } from '@angular/core';
import { IUserAttributes } from '@shared/components/profile-dropdown/profile-dropdown.component';
import { IFoldersResponse, IHome_FranchisesResponse } from '@shared/constants/models.const';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { AuthenticationService } from '../../../services/authentication.service';
import { ContentService } from '../../../services/content.service';
import { take } from 'rxjs';
import { BaseComponent } from '@shared/classes/base.class';
import { BUTTON_TYPES } from '@shared/components/button/button-types.enum';
import { LoginModalComponent } from '../../../pages/auth/login-modal/login-modal.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MatDialog } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { HelperService } from '../../../services/helper.service';
import { ResponsivityService } from '../../../services/responsivity.service';
import { ButtonComponent } from '@shared/components/button/button.component';
import { UserAvatarComponent } from '@shared/components/user-avatar/user-avatar.component';

@UntilDestroy()
@Component({
  selector: 'app-side-header',
  imports: [
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    ButtonComponent,
    UserAvatarComponent,
  ],
  templateUrl: './side-header.component.html',
  styleUrl: './side-header.component.scss',
})
export class SideHeaderComponent extends BaseComponent implements OnInit {
  readonly dialog = inject(MatDialog);
  user!: IUserAttributes;
  frItems: IHome_FranchisesResponse[] = [];
  menuItems: IFoldersResponse[] = [];
  selectedFr = '';
  protected readonly ButtonTypes = BUTTON_TYPES;
  HELPER: HelperService = inject(HelperService);

  constructor(
    override router: Router,
    public authService: AuthenticationService,
    public CONTENT: ContentService,
    private responsivityService: ResponsivityService,
  ) {
    super();
  }

  get frLoc(): string {
    return this.HELPER.frLoc;
  }


  get userName(): string {
    return `${this.user.attributes.given_name} ${this.user.attributes.family_name}`;
  }


  override ngOnInit(): void {
    super.ngOnInit();
    this.getFrList();
    this.getMenuList();

    if (this.HELPER.loginEnabled) {
      this.authService.user
        .pipe(untilDestroyed(this))
        .subscribe(user => {
          this.user = user as IUserAttributes;
        });
    }
  }

  override onReload() {
    super.onReload();
    if (this.selectedFr !== this.HELPER.frLoc) {
      this.getMenuList(true);
    }
  }

  closeMenu(): void {
    this.responsivityService.closeMenu();
  }

  getFrList(): void {
    this.CONTENT.getFranchises()
      .pipe(take(1))
      .subscribe(data => {
        this.frItems = data;
      });
  }

  getMenuList(forceReload = false): void {
    this.CONTENT.getMainMenu(forceReload)
      .pipe(
        take(1),
      ).subscribe(menu => {
      if (menu.length) {
        this.selectedFr = this.HELPER.frLoc;
        this.menuItems = menu;
      }
    });
  }

  logout(): void {
    this.authService.signOut().then(() => {
      this.authService.user.next(null);
      if (this.HELPER.getUrlArray().includes('profile')) {
        this.router.navigate([`${this.HELPER.frLoc}/home`]);
      }
    });
  }

  navigateToProfile(): void {
    this.router.navigate([`${this.HELPER.frLoc}/profile`]);
    this.closeMenu();
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(LoginModalComponent, { panelClass: 'custom-dialog' });
    dialogRef.afterClosed().pipe(untilDestroyed(this)).subscribe();
  }
}
